export const int32 = {
    MAX: 2147483647
};